/**
 * Rahber Corporation — public storefront contact & social (single source of truth).
 */

export const BUSINESS_NAME = 'Rahber Corporation';

/** Main Rahber Corporation transparent logo (trimmed of empty whitespace for crisp large display) */
export const RAHBER_LOGO_URL =
    'https://res.cloudinary.com/fl3tts9v/image/upload/e_trim/v1790969119/Logo-Photoroom_a47mr1.png';

/** High-contrast dark mode logo */
export const RAHBER_LOGO_DARK_URL =
    (process.env.PUBLIC_URL || '') + '/logo-dark.png';

export const BUSINESS_ADDRESS_SINGLE =
    'Main Bazar Chandni Chowk, Sanda Kalan, Lahore';

export const BUSINESS_ADDRESS_FULL =
    'Main Bazar Chandni Chowk, Sanda Kalan, Lahore, Pakistan';

export const BUSINESS_ADDRESS_LINES = [
    BUSINESS_NAME,
    BUSINESS_ADDRESS_SINGLE,
];

/** Google Maps — Rahber Corporation showroom */
export const BUSINESS_MAP_URL =
    'https://maps.app.goo.gl/JmiGz92pxFnCGwyq6';

export const BUSINESS_EMAIL = 'Rahbercorporation1@gmail.com';

export const BUSINESS_PHONE_MAIN = [
    { display: '042-37145264', raw: '04237145264', tel: '+924237145264' },
    { display: '0313-1451223', raw: '03131451223', tel: '+923131451223' },
    { display: '0321-8878772', raw: '03218878772', tel: '+923218878772' },
];

export const BUSINESS_PHONE_PTCL = {
    display: '042-37145264',
    raw: '04237145264',
    tel: '+924237145264',
};

/** Complaints department */
export const BUSINESS_PHONE_COMPLAINT = {
    display: '0307-4470641',
    tel: '+923074470641',
    contactName: 'Rizwan',
};

export const BUSINESS_HOURS = {
    lines: [
        'Monday to Saturday: 10:00 AM to 9:00 PM',
        'Helpline: 042-37145264 (10 am to 9 pm)',
    ],
    timingDisplay: '10:00 AM to 9:00 PM',
    phoneDisplay: '04237145264',
};

export const SOCIAL_DEALS_BLURB =
    'Follow us for new arrivals, hot installment offers & limited stock updates!';

/** WhatsApp chat (dedicated business line with attractive default greeting) */
export const BUSINESS_WHATSAPP_CHAT_URL =
    'https://wa.me/923278859655?text=' +
    encodeURIComponent('Assalam-o-Alaikum Rahber Corporation! I am interested in your appliances on cash discount and installment plans. Please share quotation and details.');

export const SOCIAL_LINKS = [
    {
        id: 'youtube',
        label: 'YouTube',
        href: 'https://www.youtube.com/@rahbercorporation',
    },
    {
        id: 'instagram',
        label: 'Instagram',
        href: 'https://www.instagram.com/rahber_corporation/',
    },
    {
        id: 'facebook',
        label: 'Facebook',
        href: 'https://www.facebook.com/share/1GpwPPR4Bp/',
    },
    {
        id: 'tiktok',
        label: 'TikTok',
        href: 'https://www.tiktok.com/@rahbercorporation',
    },
    {
        id: 'whatsapp',
        label: 'WhatsApp',
        href: 'https://wa.me/923278859655',
    },
];
